import React from "react";
import "./index.css";
import ReactDOM from "react-dom/client";
import { Amplify } from "aws-amplify";
import { App } from "./App";
import { reportWebVitals } from "./reportWebVitals";
import awsconfig from "./aws-exports";
import { initFullstory } from "./providers/FullStory";

initFullstory();
Amplify.configure(awsconfig);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
